import { __assign } from "tslib";
import { RefundMode, StepType, Unvoluntary } from './types';
import { getPassengerFirstName, getPassengerLastName } from '../Checkout/store/passengers/selectors';
import { initialState as stepsInitialState } from './store/steps/reducer';
import { TravellerFieldEnum } from '@websky/graphql';
import { capitalizeFirstLetter } from '../utils';
export var useCheckoutOrderRefundAdapter = function (order) {
    var passengers = {};
    var isOnlyPassenger = order.travellers.length === 1;
    order.travellers.forEach(function (traveller) {
        var _a, _b, _c, _d;
        if (traveller.linkedTraveller) {
            return;
        }
        passengers[traveller.id] = {
            id: traveller.id,
            name: "".concat(capitalizeFirstLetter(getPassengerFirstName(traveller).value.toLowerCase()), " ").concat(capitalizeFirstLetter(getPassengerLastName(traveller).value.toLocaleLowerCase())),
            children: order.travellers
                .filter(function (orderTraveller) { var _a; return ((_a = orderTraveller.linkedTraveller) === null || _a === void 0 ? void 0 : _a.id) === traveller.id; })
                .map(function (orderTraveller) { return ({
                name: "".concat(capitalizeFirstLetter(getPassengerFirstName(orderTraveller).value.toLowerCase()), " ").concat(capitalizeFirstLetter(getPassengerLastName(orderTraveller).value.toLocaleLowerCase())),
                id: orderTraveller.id
            }); }),
            selected: isOnlyPassenger,
            phone: (_b = (_a = traveller.values) === null || _a === void 0 ? void 0 : _a.find(function (value) { return value.type === TravellerFieldEnum.Phone; })) === null || _b === void 0 ? void 0 : _b.value,
            email: (_d = (_c = traveller.values) === null || _c === void 0 ? void 0 : _c.find(function (value) { return value.type === TravellerFieldEnum.Email; })) === null || _d === void 0 ? void 0 : _d.value
        };
    });
    var documents = {};
    order.travellers.forEach(function (traveller) {
        if (!traveller.linkedTraveller) {
            documents[traveller.id] = [];
        }
    });
    var stepsState = isOnlyPassenger
        ? stepsInitialState.map(function (step) {
            if (step.type === StepType.Reason) {
                return __assign(__assign({}, step), { isActive: true });
            }
            return __assign(__assign({}, step), { isActive: false });
        })
        : stepsInitialState;
    return {
        passengers: passengers,
        reason: order.exareInfo.refundAutoMode ? Unvoluntary.Unvoluntary : null,
        steps: stepsState,
        mode: order.exareInfo.refundAutoMode ? RefundMode.Auto : RefundMode.Manual,
        customer: null,
        documents: documents,
        flightId: order.flight.id,
        orderId: order.id,
        refundInfo: {},
        aviaOrder: order
    };
};
